import React from 'react';

import "./Styles/ParentDisabled.scss";

const ButtonLoadingCircle = ({ show }: {show:boolean}) => {

    return (<div className={`ParentDisabled ${show?'Show':''}`} />);
}

export default ButtonLoadingCircle;